import { render, staticRenderFns } from "./ProductCategoryDeleteModal.vue?vue&type=template&id=3d896335&scoped=true&"
import script from "./ProductCategoryDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d896335",
  null
  
)

export default component.exports